import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { isAuthRoute } from '../../navigation/authRoutes';
import { useCurrentRouteName } from '../../widget/useCurrentRouteName';
import { isAutoGeneratedDisplayName } from '../../utils/isAutoGeneratedDisplayName';
import { OnboardingProfileModal } from './OnboardingProfileModal';
import { isCompactOnboardingRoute } from './onboardingProfileForm';

/**
 * Renders the onboarding profile modal as an overlay whenever an
 * authenticated user still has the BE-seeded auto-name (`"Гость XXXX"`,
 * `null`, `''`, or `"User"`). Mount as a sibling of `<NavigationContainer>`
 * inside `AppContent` — must be inside `<AuthProvider>` to read `useAuth()`.
 *
 * The gate self-unmounts the modal once `refreshUser()` pulls the new
 * displayName from the backend; no manual close handler is needed.
 *
 * CORE-513 — но не на экранах входа и регистрации. Гейт живёт рядом с
 * навигатором и про маршрут не знает, поэтому авторизованный человек, открывший
 * `/register`, получал «Добро пожаловать в Agapella» поверх формы регистрации.
 * Условие само по себе верное — авторизован, имя ещё автоматическое, — просто
 * задано не в том месте: приветствовать посреди страницы входа рано.
 *
 * CORE-1309 — и не полной анкетой поверх эфира: в Live спрашиваем только имя и
 * фамилию (`isCompactOnboardingRoute`).
 */
export function OnboardingProfileGate() {
  const { user, isAuthenticated, isLoading } = useAuth();
  const route = useCurrentRouteName();

  if (isAuthRoute(route)) return null;
  if (isLoading || !isAuthenticated || !user) return null;
  if (!isAutoGeneratedDisplayName(user.displayName)) return null;

  return <OnboardingProfileModal compact={isCompactOnboardingRoute(route)} />;
}
